import { useEffect, useState } from 'react';

// Third-parties.
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Splitter, SplitterPanel } from 'primereact/splitter';
import { TreeTable, TreeTableExpandedKeysType,
	TreeTableSelectionKeys } from 'primereact/treetable';

// Types.
import ExecutionPlan from '../../../types/instance/ExecutionPlan';

// Helpers.
import { Step, formatNumber, getStepDetails } from '../../../helpers/utils';

// Components.
import GenericPlan from './GenericPlan';
import KnowledgeBasePlanButton from '../../buttons/KnowledgeBasePlanButton';

export default function MongoPlan (props: { executionPlan: ExecutionPlan,
	hasObjectStatistics: boolean })
{
	const [treeSteps, setTreeSteps] = useState<Step[]> ([]);
	const [expandedKeys, setExpandedKeys] =
		useState<TreeTableExpandedKeysType> ({});
	const [selectedStepKey, setSelectedStepKey] =
		useState<TreeTableSelectionKeys> (null);
	const [stepDetails, setStepDetails] = useState<any[]> ([]);
	const [stepOperation, setStepOperation] = useState<string> ('');

	function getStepOperation (details: any[]): string
	{
		const detail: any[] =
			details.filter (detail => detail.name === 'operation');
		return detail.length === 1 ? detail[0].value : '';
	}

	useEffect (() =>
	{
		let n: number = 0;
		const expanded: TreeTableExpandedKeysType = {};

		function getKey (): string
		{
			return String (++n);
		}

		function logMissedField (_field: string, _type: string): void
		{
			// console.log ('Missed ' + field + ': ' + type);
		}

		function getData (plan: any): any
		{
			const data: any = { operation: 'query' };

			for (const field in plan)
			{
				const type: string = typeof (plan[field]);

				if (type === 'string' || type === 'boolean')
				{
					data[field] = String (plan[field]);
				}
				else if (type === 'number')
				{
					data[field] = formatNumber (plan[field]);
				}
				else if (type === 'object')
				{
					// Special handling for interesting sub-objects.
					const object = plan[field];

					if (field === 'queryPlanner')
					{
						data.object = object.namespace;
					}
					else if (field === 'command')
					{
					}
					else
					{
						logMissedField (field, type);
					}
				}
				else
				{
					logMissedField (field, type);
				}
			}

			return data;
		}

		function getStep (plan: any): Step
		{
			const key: string = getKey ();
			expanded[key] = true;
			const children: any[] = [];
			return {
				key: key,
				data: getData (plan),
				children: children.map ((child: any) => getStep (child))
			};
		}

		const plan: any = JSON.parse (props.executionPlan.sqlplan);
		const tree: Step[] = [];
		tree.push (getStep (plan));
		setTreeSteps (tree);
		setExpandedKeys (expanded);
		setSelectedStepKey ('1');
	}, [props.executionPlan.sqlplan]);

	useEffect (() =>
	{
		const details = getStepDetails (treeSteps, selectedStepKey);
		const operation: string = getStepOperation (details);
		setStepDetails (details);
		setStepOperation (operation);
	}, [treeSteps, selectedStepKey]);

	if (treeSteps.length === 0)
	{
		return (<GenericPlan executionPlan={props.executionPlan} />);
	}

	return (
		<Splitter>
			<SplitterPanel size={65} className="plan-master-panel">
				<TreeTable
					value={treeSteps}
					expandedKeys={expandedKeys}
					onToggle={e => setExpandedKeys (e.value)}
					selectionMode="single"
					resizableColumns
					reorderableColumns
					selectionKeys={selectedStepKey}
					onSelectionChange={e => setSelectedStepKey (e.value)}
					className="treetable-responsive"
				>
					<Column header="Operation" field="operation" expander
						className="col-width-45 plan-first-column"/>
					<Column header="Object" field="object"
						className="col-width-25"/>
					<Column header="Cost" field="cost"
						className="col-width-15 text-end"/>
					<Column header="Rows" field="rows"
						className="col-width-15 text-end"/>
				</TreeTable>
			</SplitterPanel>
			<SplitterPanel size={35} className="plan-detail-panel">
				<DataTable value={stepDetails} resizableColumns stripedRows>
					<Column header="Name" field="name"
						className="col-width-50 plan-first-column"/>
					<Column header="Value" field="value"
						className="col-width-50"/>
				</DataTable>
				<KnowledgeBasePlanButton databaseType="mongodb"
					planOperation={stepOperation}
					planOption=""/>
			</SplitterPanel>
		</Splitter>
	);
}
